import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import l from "./styles/index.cssr.js";
import d from "../../../_mixins/use-style.js";
import u from "../../icon-switch-transition/src/IconSwitchTransition.js";
import { defineComponent as f, h as t } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as c } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const s = "1.6s", p = {
  strokeWidth: {
    type: Number,
    default: 28
  },
  stroke: {
    type: String,
    default: void 0
  }
}, k = f({
  name: "BaseLoading",
  props: Object.assign({
    clsPrefix: {
      type: String,
      required: !0
    },
    show: {
      type: Boolean,
      default: !0
    },
    scale: {
      type: Number,
      default: 1
    },
    radius: {
      type: Number,
      default: 100
    }
  }, p),
  setup(r) {
    d("-base-loading", l, c(r, "clsPrefix"));
  },
  render() {
    const {
      clsPrefix: r,
      radius: a,
      strokeWidth: o,
      stroke: i,
      scale: n
    } = this, e = a / n;
    return t("div", {
      class: `${r}-base-loading`,
      role: "img",
      "aria-label": "loading"
    }, t(u, null, {
      default: () => this.show ? t("div", {
        key: "icon",
        class: `${r}-base-loading__transition-wrapper`
      }, t("div", {
        class: `${r}-base-loading__container`
      }, t("svg", {
        class: `${r}-base-loading__icon`,
        viewBox: `0 0 ${2 * e} ${2 * e}`,
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          color: i
        }
      }, t("g", null, t("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${e} ${e};270 ${e} ${e}`,
        begin: "0s",
        dur: s,
        fill: "freeze",
        repeatCount: "indefinite"
      }), t("circle", {
        class: `${r}-base-loading__icon`,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": o,
        "stroke-linecap": "round",
        cx: e,
        cy: e,
        r: a - o / 2,
        "stroke-dasharray": 5.67 * a,
        "stroke-dashoffset": 18.48 * a
      }, t("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${e} ${e};135 ${e} ${e};450 ${e} ${e}`,
        begin: "0s",
        dur: s,
        fill: "freeze",
        repeatCount: "indefinite"
      }), t("animate", {
        attributeName: "stroke-dashoffset",
        values: `${5.67 * a};${1.42 * a};${5.67 * a}`,
        begin: "0s",
        dur: s,
        fill: "freeze",
        repeatCount: "indefinite"
      })))))) : t("div", {
        key: "placeholder",
        class: `${r}-base-loading__placeholder`
      }, this.$slots)
    }));
  }
});
export {
  k as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/loading/src/Loading.js
// module id = 147
// module chunks = 67